import api from "../api";

export const getChecklists = (params) => api.get("/safety-checklists", { params });
export const getChecklist = (id) => api.get(`/safety-checklists/${id}`);
export const getChecklistTemplate = () => api.get("/safety-checklists/template");
export const createChecklist = (data) => api.post("/safety-checklists", data);
export const updateChecklist = (id, data) => api.patch(`/safety-checklists/${id}`, data);
export const deleteChecklist = (id) => api.delete(`/safety-checklists/${id}`);
export const approveChecklist = (id, data) => api.patch(`/safety-checklists/${id}/approve`, data);
export const getChecklistStats = (params) => api.get("/safety-checklists/stats", { params });

export const downloadChecklistExcel = (id) =>
 api.get(`/safety-checklists/${id}/excel`, { responseType: "blob" });
